<template>
    <div class="container-fluid no-min-height">
        <div class="row">
            <div class="col-12 col-lg-6 offset-lg-3">
                <h2 class="mb-4">
                    Klachtenformulier
                </h2>

                <div class="position-relative">
                    <transition name="fade">
                        <form v-if="!success" key="form">
                            <div class="col-12">
                                <h3>Ik ben een</h3>
                            </div>
                            <DropdownInput
                                v-model="form.userType"
                                :options="userTypes"
                                name="Relatie tot het Horizon College"
                                rules="required"
                            />
                            <hr />
                            <div class="col-12">
                                <h3>Gegevens</h3>
                            </div>

                            <TextInput
                                v-model="form.fullName"
                                v-validate="'required'"
                                data-vv-as="Naam"
                                :disabled="processing"
                                :error="errors.first('fullName')"
                                :name="'Full Name'"
                                :label="'Uw naam'"
                                :placeholder="'Naam en achternaam'"
                            ></TextInput>

                            <TextInput
                                v-model="form.phoneNumber"
                                v-validate="'required'"
                                data-vv-as="Telefoonnummer"
                                :disabled="processing"
                                :error="errors.first('phoneNumber')"
                                :name="'phoneNumber'"
                                :label="'Telefoonnummer'"
                                :placeholder="'Telefoonnummer'"
                            ></TextInput>

                            <TextInput
                                v-model="form.email"
                                v-validate="'email'"
                                data-vv-as="E-mailadres"
                                :disabled="processing"
                                :error="errors.first('email')"
                                :name="'email'"
                                :label="'E-mailadres'"
                                :placeholder="'E-mailadres'"
                                :type="'email'"
                            ></TextInput>

                            <TextInput
                                v-if="form.userType !== 'Student'"
                                v-model="form.studentName"
                                data-vv-as="Student"
                                :disabled="processing"
                                :error="errors.first('studentName')"
                                :name="'studentName'"
                                :label="'Naam student'"
                                :placeholder="'Naam student (niet verplicht)'"
                            ></TextInput>

                            <DropdownInput
                                v-model="form.location"
                                :options="locations"
                                name="Locatie"
                                rules="required"
                            />
                            <hr />
                            <div class="col-12">
                                <h3>Klacht</h3>
                            </div>

                            <DropdownInput
                                v-model="form.complaintReason"
                                :options="complaintReasons"
                                name="Waar gaat je klacht over?"
                                rules="required"
                            />

                            <TextInput
                                v-if="form.complaintReason == 'Overig: n.l'"
                                v-model="form.complaintReasonExtra"
                                data-vv-as="complaintReasonExtra"
                                :disabled="processing"
                                :error="errors.first('complaintReasonExtra')"
                                :name="'complaintReasonExtra'"
                                :label="'Overig:'"
                                :placeholder="'Uw klacht'"
                            ></TextInput>
                            <p class="complaint__text">
                                Met wie binnen het Horizon College heb je
                                contact gehad over deze kwestie, voordat je
                                besloot een klacht in te dienen?
                            </p>
                            <TextInput
                                v-model="form.contactName"
                                v-validate="'required'"
                                data-vv-as="contactName"
                                :disabled="processing"
                                :error="errors.first('contactName')"
                                :name="'contactName'"
                                :label="'Naam:'"
                                :placeholder="'Naam contactpersoon'"
                                class="input--flex"
                            ></TextInput>
                            <TextInput
                                v-model="form.contactFunction"
                                v-validate="'required'"
                                data-vv-as="contactFunction"
                                :disabled="processing"
                                :error="errors.first('contactFunction')"
                                :name="'contactFunction'"
                                :label="'Functie:'"
                                :placeholder="'Functie contactpersoon'"
                                class="input--flex"
                            ></TextInput>

                            <TextAreaInput
                                v-model="form.message"
                                data-vv-as="Bericht"
                                :disabled="processing"
                                :error="errors.first('message')"
                                :name="'message'"
                                :label="'Vul hier uw klacht in'"
                                :rows="5"
                                :placeholder="'Vul hier uw klacht in'"
                            ></TextAreaInput>

                            <button
                                class="btn btn-primary float-right mb-1"
                                :disabled="processing"
                                @click.prevent="validateAndSubmit"
                            >
                                verstuur
                            </button>
                        </form>
                        <div v-else key="successMessage" class="rte">
                            Bedankt voor uw aanvraag. Wij hebben deze in goede
                            orde ontvangen. Wij zullen zo snel mogelijk contact
                            met u opnemen.
                        </div>
                    </transition>
                    <div
                        v-if="!success && error"
                        key="errorMessage"
                        class="rte form-failed"
                        v-html="errorMessageFromApi"
                    ></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import Axios from 'axios';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import FormSubmissionMixin from '@/js/mixins/form-submission-mixin.js';
import TextInput from '@/components/form/text-input';
import DropdownInput from '@/components/form/dropdown-input';
import TextAreaInput from '@/components/form/textarea-input';
import VeeValidate from 'vee-validate';

Vue.use(VueReCaptcha, { siteKey: '6LfB5cMUAAAAAOnv1Nn1d1neosmH_X5xVuUx0zu4' });
Vue.use(VeeValidate);

VeeValidate.Validator.extend('minLength', {
    getMessage(field, [length]) {
        return `At least ${length} items must be selected.`;
    },
    validate(value, [length]) {
        return value.length >= length;
    }
});

export default {
    components: {
        TextInput,
        TextAreaInput,
        DropdownInput
    },

    mixins: [FormSubmissionMixin],

    props: {
        formData: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            form: {
                userType: '',
                fullName: '',
                phoneNumber: '',
                email: '',
                location: '',
                complaintReason: '',
                complaintReasonExtra: '',
                contactName: '',
                contactFunction: '',
                message: '',
                studentName: ''
            },
            userTypes: [
                {
                    name: 'Ouder'
                },
                {
                    name: 'Student'
                },
                {
                    name: 'Anders'
                }
            ],
            complaintReasons: [
                {
                    name: 'Communicatie'
                },
                {
                    name: 'Onderwijs'
                },
                {
                    name: 'Leermiddelen'
                },
                {
                    name: 'BPV'
                },
                {
                    name: 'Examinering'
                },
                {
                    name: 'Facilitair / ICT'
                },
                {
                    name: 'Overig: n.l'
                }
            ],
            locations: [],
            postUrl: '/api/ComplaintsFormApi/Submit'
        };
    },

    computed: {
        errorMessageFromApi() {
            if (!this.errorMessage.length) {
                return this.formData.errorMessage;
            }

            return this.errorMessage;
        }
    },

    created() {
        this.getLocations();
    },

    methods: {
        getLocations() {
            const url = '/api/ComplaintsFormApi/GetLocations';
            Axios({
                method: 'get',
                url: url
            })
                .then(response => {
                    if (!response.data === null) {
                        return false;
                    }

                    this.locations = response.data;
                    return true;
                })
                .catch(() => false);
        }
    }
};
</script>

<style lang="scss" scoped>
.grecaptcha-badge {
    display: none;
}

.fade-enter-active,
.fade-leave-active {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    transition: opacity 0.5s $easeOutQuad, transform 0.5s $easeOutQuad;
}

.fade-enter {
    opacity: 0;
    transform: translateX(-100%);
}

.fade-leave-to {
    opacity: 0;
    transform: translateX(100%);
}

hr {
    margin-top: 2rem;
    margin-bottom: 2rem;
    border: 0;
    border-top: 2px solid rgba(0, 0, 0, 0.1);
}

.complaint__text {
    margin-left: 1.275rem;
    margin-top: 2rem;
    margin-bottom: 1rem;
}

.input--flex {
    display: flex;
    flex-wrap: wrap;
}
</style>
